import { render, staticRenderFns } from "./AddProgramToUsergroupDialog.vue?vue&type=template&id=177a4574&lang=pug"
import script from "./AddProgramToUsergroupDialog.vue?vue&type=script&lang=js"
export * from "./AddProgramToUsergroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports